import type { LinkUrl, LinksLinkComponent } from '@twisto/api-cms'
import { Link as DefaultLink } from '@twisto/components/atoms/link'
import { Typography } from '@twisto/components/atoms/typography'

import { getLinkUrl } from 'homepage/utils'

import * as styles from './base-link.styles'

export const BaseLink = ({
  url,
  newTab,
  text,
  color,
  underline,
  hover,
  fontWeight,
  variant,
  inverted = false,
}: LinksLinkComponent & { inverted?: boolean }) => (
  <DefaultLink
    hover={hover}
    href={url}
    target={newTab === true ? '_blank' : undefined}
    to={getLinkUrl({ url } as LinkUrl)}
    underline={underline}
    variant={variant}
  >
    <Typography
      color={color}
      component="span"
      css={inverted && styles.inverted}
      fontWeight={fontWeight}
    >
      {text}
    </Typography>
  </DefaultLink>
)
